export const COURSE = '/course/' as const
export const COURSE_ALL = `${COURSE}all` as const
